import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

export const getConsultationState = (state: RootState) => state.consultation;

export const selectConsultations = createSelector(
  [getConsultationState],
  (consultationState) => consultationState.consultations
);

export const selectLoadingConsultations = createSelector(
  [getConsultationState],
  (consultationState) => consultationState.loadingConsultations
);

export const selectConsultationTypes = createSelector(
  [getConsultationState],
  (consultationState) => consultationState.consultationTypes
);

export const selectLoadingCreateConsultation = createSelector(
  [getConsultationState],
  (consultationState) => consultationState.loadingCreateConsultation
);
